import React, { useState } from "react";
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import Grid from '@mui/material/Grid';
import LoadingButton from '@mui/lab/LoadingButton';
import {saveAs} from 'file-saver';
import { Link, useNavigate } from "react-router-dom";

import axios from 'axios';
import '../App.css';
import moon from '../moon_over_bridge.png';
import downloadIcon from '../downloadIcon.png';
import editIcon from '../editIcon.png'; 


//const localhostAPI = "http://127.0.0.1:5000";
//const API = "https://generative-backend.herokuapp.com" 
const API = "https://generativeapp.com" 

const Home = ({setResponse}) => {
  const [prompt, setPrompt] = useState("Moon over the bridge with a rainbow background");
  const [image, setImage] = useState(moon)
  const [isLoading, setIsLoading] = useState(false)
  const [isSuggesting, setIsSuggesting] = useState(false)
  const [isRegisteringEmail, setIsRegisteringEmail] = useState(false)  
  const [email, setEmail] = useState("email")  


    const navigate = useNavigate()

    const goToEdit = () => {
        setResponse(image)
        navigate('/edit')
    }

    const registerEmail = () => {
      setIsRegisteringEmail(!isRegisteringEmail)
    }

    const inference = () => { 
      setIsLoading(true)
      const payload = {"prompt": prompt}
      const headers = { "Content-Type": "application/json" }
      axios.post(API + "/inference", payload, headers) 
      .then((res) => {
        setImage(res.data.url)
        setIsLoading(false) 
      }).catch((error) => {
        if (error.response.status === 400) {
          alert("Provide a different prompt")
        }
        else{ 
          alert("Update in progress. Service will resume within 1 hour.")
        }
        setIsLoading(false)
      });
    }

    const getPromptSuggestion = () => { 
      setIsSuggesting(true)
      axios.get(API + "/recommendation")
      .then((res) => {
        //alert(res)
        setPrompt(res.data.prompt)
        setIsSuggesting(false)
      }).catch((error) => {
        alert("Suggestions will resume soon. The prompt bar for image generation still works.")
        setIsSuggesting(false)
      });
    }
  
  const download = () => {
    saveAs(image, "generated-image.png")
  }

  return (
    <>
    {/* <div style={{"position":"absolute", "left": "15px", "top": "15px", "background-color": "#323f51", "padding": "10px", "borderRadius": "3%"}}>
        <div className="NavTitle" style={{"fontSize": "xx-large"}}>
          <Link  className="NavLink" to={"/"}>
            <div>Content</div> <div className="NavAI">AI</div>
          </Link>
        </div>
      </div> */}
      <div className="Nav" >

      <div className="NavFirstHalf">
        <div className="NavTitle">
          <Link  className="NavLink" to={"/"}>
            Content<div className="NavAI">AI</div>
          </Link>
        </div>
      </div>
      
      <div className="NavSecondHalf">
        {
          isRegisteringEmail ? 
          <div className="EmailContainer">
          <TextField
          value={email}
          sx={{ input: { color: 'white'}}}
          style={{width: "100%"}}
          
          
          color="info"
          onChange={(e) => {
            setEmail(e.target.value);
          }} />
          <button className="RegisterEmailButton" onClick={registerEmail}>Register</button>
          </div>
        :
        <button className="btn btn-white" onClick={registerEmail}>Go Pro</button>

        }
      </div>
    </div>  
    
      <div className="App-header">
        <h3>Enter Your Prompt</h3>
        <div className="Grid">
          <Grid container spacing={0}>
            <Grid item xs={12} >
              <div className="PromptBarAndGenerateButton">
                <TextField
                  value={prompt}
                  sx={{ input: { color: 'white'}}}
                  style={{width: "100%"}}
                  size='large'
                  label="creative prompt"
                  color="primary"
                  onChange={(e) => {
                    setPrompt(e.target.value);
                  }} />
                {isLoading ? <Button> Generating </Button> :
                <Button variant="contained" size="medium" onClick={inference}> Generate </Button> }
              </div>
            </Grid>
            <Grid item xs={8} container>
              <LoadingButton 
                loading={isSuggesting} 
                variant="text" 
                loadingIndicator={<CircularProgress size="1rem"/>}
                color="info" 
                size="small"
                onClick={getPromptSuggestion}>
                suggest prompt
              </LoadingButton>
            </Grid>
          </Grid>
        </div> 

        { 
        isLoading ? 

        <div className="Loading"><CircularProgress size="4rem"/></div> : 
        
        <div className="Download">
          <img className="GeneratedImage" src={image} alt=""/>
          {/* Icons8.com */}
          <div className="IconContainer">
            <img className="Icon" src={downloadIcon} alt="download" title="download" onClick={download}/>
            {/* <img className="Icon" src={editIcon} alt="edit" title="edit" onClick={goToEdit}/> */}
          </div>
          {/* <button className="DownloadButton" onClick={download}>download</button> */}
        </div>  
        }

      </div>
    </>
  );
}

export default Home;